// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3QOC_","loaderOuter":"PageOverlayLoader_loaderOuter__1k75h"};